import { FaQuoteRight, FaUser } from 'react-icons/fa';
import { DashboardReviewHistory } from '../../../types/dashboard';
import AcademiaRating from '../AcademiaRating';

const ReviewCard = ({ review }: { review: DashboardReviewHistory }) => {
  // destructuring the review object here
  const { comments, ratings, associate_name, service_provided } = review || {};

  // rendering review card component here
  return (
    <div className='border-2 border-base-dark-green rounded-lg p-3'>
      <div className='relative py-2 overflow-hidden'>
        <AcademiaRating
          size={30}
          ratingValue={ratings}
          isReadonly
          extraClassNames='relative z-10 justify-center'
        />

        <div className='relative z-10 h-[140px]'>
          <p
            title={comments}
            className='italic text-lg text-base-dark-blue text-center line-clamp-5'
          >
            <q className='text-ellipsis'>{comments}</q>
          </p>
        </div>

        <FaQuoteRight className='absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 size-full text-base-light-green/25' />
      </div>

      <div className='flex items-center justify-center gap-2'>
        <div className='flex items-center justify-center bg-base-light-gray size-[50px] rounded-full'>
          <FaUser className='text-gray-300 size-7' />
        </div>

        <div className='flex flex-col items-start'>
          <p className='text-sm text-base-dark-green font-medium'>
            {associate_name}
          </p>
          <span className='text-xs text-base-light-blue'>
            Associate, {service_provided}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
